import React, { useEffect, useRef, useState } from "react";
import r1 from '../../media/Roadmap-1.png';
import r2 from '../../media/Roadmap-2.png';
import r3 from '../../media/Roadmap-3.png';
import r4 from '../../media/Roadmap-4.png';
import r5 from '../../media/Roadmap-5.png';
import r6 from '../../media/Roadmap-6.png';
import r7 from '../../media/Roadmap-7.png';
import large from '../../media/Tiles-Background-Large.jpg';
import ipad from '../../media/Tiles-Background-ipad.png';
import iphone from '../../media/Tiles-Background-iphone.png';

import '../../css/mk-brand.css';
import '../../css/mk-roadmap.css';
import '../../css/time-line-styles.css';

function RoadmapPanel() {
    return (
        <div id="roadmap-panel" className="container p-4">
            <div className="flex text-center justify-center">
                <h1 className="z-30 text-white text-4xl font-extrabold">mk</h1>
                <h1 className="z-30 text-brand text-4xl font-extrabold">Roadmap</h1>
            </div>
            <div className="h-2" />
            <div className="relative">
                <div className="flex flex-wrap -mx-4 justify-center lg:mx-auto lg:max-w-screen-lg">
                    <div className="z-30 mt-8">
                        <img src={r1}/>
                    </div>
                    <div className="z-30 lg:mt-8">
                        <img src={r2}/>
                    </div>
                    <div className="z-30 lg:mt-8">
                        <img src={r3}/>
                    </div>
                    <div className="z-30 lg:mt-8">
                        <img src={r4}/>
                    </div>
                    <div className="z-30 ">
                        <img src={r5}/>
                    </div>
                    <div className="z-30 ">
                        <img src={r6}/>
                    </div>
                    <div className="z-30 ">
                        <img src={r7}/>
                    </div>
                </div>
                <div className="z-10 absolute top-0">
                    <picture>
                        <source srcSet={large} media="(min-width: 1024px)" />
                        <source srcSet={ipad} media="(min-width: 768px)" />
                        <img src={iphone} className="z-10 mx-auto container" alt="metaKitchen Roadmap background" />
                    </picture>
                </div>
            </div>

        </div>
    );
}
export default RoadmapPanel;